import React from 'react';
import { Box, Typography, useTheme, alpha } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const FeatureItem = ({ children }) => {
  const theme = useTheme();
  
  return (
    <Box 
      sx={{ 
        display: "flex", 
        alignItems: "flex-start", 
        gap: 1,
        borderRadius: 1,
        transition: 'all 0.2s ease',
        '&:hover': {
          background: alpha(theme.palette.primary.main, 0.05),
        }
      }}
    >
      <CheckCircleOutlineIcon 
        color="primary" 
        fontSize="small" 
        sx={{ 
          mt: 0.25,
          color: alpha(theme.palette.primary.main, 1),
          fontSize: '1rem',
          flexShrink: 0,
        }} 
      />
      <Typography 
        variant="body2" 
        sx={{ 
          color: alpha(theme.palette.text.secondary, 0.85),
          fontWeight: 500,
          lineHeight: 1.2,
          fontSize: { xs: '0.875rem', md: '0.920rem' },
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default FeatureItem; 